export * from './fileUpLoad.js'
export * from './getUserInfo.js'
export * from './pushUserInfo.js'
export * from './fundAccount.js'

import JSBridge from '@fs/jsbridge/dist/lib/jsBridge.js'
import { Toast } from 'vant'
import store from '@/store/openAccount/index'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import initI18n from '../../i18n/tools'
import { getQueryString, getLangType } from '@/utils'
import { isCMHK } from '@/utils/tools'
import MYLINK_JSBRIDGE from '@fs/jsbridge/dist/lib/mylinkJsBridge.js'
import { isComplianceInOutFlow } from '@/utils/complianceSession'

Vue.use(VueI18n)
const i18n = initI18n({})

// finfo特定的AECODE
export const finfoAECodes = ['W090-A', 'W090-B', 'W090-C', 'W090-D']

export const customizeRequest = async (
    request,
    successCallback,
    { loadingMsg = i18n.t('requestCode.jzz'), showMessage = true, message = i18n.t('requestCode.qzsb'), errorHandler = null } = {}
) => {
    if (!request) return
    try {
        // Toast.loading({
        //     duration: 0,
        // 	message: loadingMsg,
        //     forbidClick: true
        // })
        store.commit('user/updateShowLoading', [true, loadingMsg])
        const res = await request()
        // Toast.clear()
        store.commit('user/updateShowLoading', false)
        if (successCallback && res?.data?.result) {
            successCallback && (await successCallback(res))
            return true
        }
        const { code } = res?.data?.error || {}
        if (code == 100008 || code == 100033 || code == 100034) {
            //100008 session 错误 ; 100033 uin 错误 ; 100034 session 被踢
            if (JSBridge) {
                //
            } else {
                if (isCMHK()) {
                    // 出现了 以上相关问题不能获取接口的时候也退出重新授权
                    setTimeout(() => {
                        MYLINK_JSBRIDGE.backToHomePage()
                    }, 2000)
                } else {
                    const aeCode = getQueryString('aeCode') || ''
                    const channel = getQueryString('channel') || ''
                    console.log(aeCode, channel)
                    window.location.href = `./login.html?langType=${getLangType()}#/?aeCode=${aeCode}&channel=${channel}`
                }
            }
            Toast(i18n.t('requestCode.dlsxqcxdl'))
        } else {
            if (code == 150200) showMessage && Toast(message)
            if (errorHandler) {
                await errorHandler(res)
            }
        }
        return false
    } catch (err) {
        store.commit('user/updateShowLoading', false)

        // 在合规出入金场景下不显示服务器异常提示
        if (!isComplianceInOutFlow()) {
            Toast(i18n.t('requestCode.fwqzwxyqshzs'))
        }

        console.log('request error:', err)
        return false
    }
}
